module.exports = __webpack_public_path__ + "img/Firma1.5cc8f04c.svg";